import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditPencil from '../../../../../Assets/StorefrontIcons/EditPencil.svg';
import Delete from '../../../../../Assets/DeleteRed.svg';
import { setSectionType, setSectionFormType, removeAboutSection } from '../../../../../Features/storefrontSlice';

function FeatureSection({ feature }) {
    const [iconSize, setIconSize] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);

    useEffect(() => {
        setIconSize((zoomSize/100)*16);

        setHeadingSize((zoomSize/100)*10);
        setHeadingHeight((zoomSize/100)*18);
    }, [zoomSize]);

    return (
        <div className="flex flex-col items-center gap-[6px]">
            <div style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                <img className='size-full' src={feature?.imageLink} alt={feature.altText} />
            </div>

            <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='font-semibold text-[#000000]'>{feature.Heading}</h1>
        </div>
    )
}

function FeaturesTwo({ item }) {
    const dispatch = useDispatch();

    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.storeAbout.find(section => section.item.TypeData === item.item.TypeData);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('FEATURES_TWO_DESKTOP'));
    }

    function handleDeleteClick() {
        dispatch(removeAboutSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className='w-full grid grid-cols-4 gap-x-2 gap-y-2 px-4 relative'
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesTwo;
